import { observer } from 'mobx-react-lite'
import type { FC, CSSProperties } from 'react'
import { useState } from 'react'
import { Modal } from '../../../../components/modal'
import { SelectableList } from '../../../../components/modals'
import type { Placement } from '@floating-ui/react'
import type { Stores } from '../../../../util/store'
import { useManufacturers } from '../../../../stores/manufacturers-store'

export interface ManufacturersModalProps {
    anchor?: HTMLElement
    placement?: Placement
    stores: Stores
    onClose(): void
    style?: CSSProperties
    containerStyle?: CSSProperties
    onBack?(): void
    selectedId?: string
    onSelect(id: string): void
}

export const ManufacturersModal: FC<ManufacturersModalProps> = observer(
    ({
        anchor,
        placement,
        stores,
        onClose,
        style,
        containerStyle,
        onBack,
        selectedId,
        onSelect,
    }) => {
        const [selectedIds] = useState(() =>
            selectedId ? new Set([selectedId]) : undefined,
        )
        const manufacturers = useManufacturers(stores)

        return (
            <Modal
                placement={placement}
                anchor={anchor}
                onClose={onClose}
                style={style}
                containerStyle={containerStyle}
                onBack={onBack}>
                <SelectableList
                    items={manufacturers}
                    selectedIds={selectedIds}
                    onSelect={(item) => onSelect(item.id)}
                    isLoading={
                        stores.manufacturers.isFetching ||
                        stores.manufacturers.isUpdating
                    }
                    placeholder="Search manufacturer"
                />
            </Modal>
        )
    },
)
